import { stringify } from '@angular/compiler/src/util';
import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/constants';
import { Activity } from 'src/app/shared/model/activity';
import { ActivityService } from 'src/app/shared/services/activity.service';
import { ErrorService } from 'src/app/shared/services/error.service';
import { Utilities } from 'src/app/shared/utilities';

@Component({
  selector: 'app-activitydashboard',
  templateUrl: './activitydashboard.component.html',
  styleUrls: ['./activitydashboard.component.scss']
})
export class ActivityDashboardComponent implements OnInit {
  advSearch: boolean;
  perPage = constants.recordsPerPage.activitydashboard;
  currentPage: number;

  activities: Activity[];
  subsetActivities: Activity[];
  loadedActivities: boolean;
  
  // search fields
  type: string;
  dateFrom: string;
  dateTo: string;

  constructor(private activitySearch: ActivityService, private errorService: ErrorService) {
  }

  ngOnInit() {
    //initilization
    this.advSearch = false;
    this.currentPage = 1;
    this.loadedActivities = false;
  
    this.dateFrom = Utilities.getTodayMinusDays(7);
    this.dateTo = Utilities.getToday();

    // load activity
    this.activitySearch.loadActivityDays(7, false)
      .then(res => {
        this.activities = res;
        this.subsetActivities = this.activities.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);
        this.loadedActivities = true;
      })
      .catch(err => {
        this.errorService.handlerError(err);
      });
  }

  pageActivity($event){
    this.loadedActivities = false;
    this.subsetActivities = this.activities.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);  
    this.loadedActivities = true;
  }

  search() {
    if(this.dateFrom && this.dateTo){
      this.currentPage = 1;
      this.loadedActivities = false;
      // load activity
      this.activitySearch.loadActivity(this.dateFrom, this.dateTo, false, this.type)
      .then(res => {
        this.activities = res;
        this.subsetActivities = this.activities.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);
        this.loadedActivities = true;
      })
      .catch(err => {
        this.errorService.handlerError(err);
      });
    }else{
      this.errorService.handlerError("Date range must be selected");
    }
  }

  reset() {
    delete this.type;
    delete this.dateFrom;
    delete this.dateTo;
    this.ngOnInit();
  }

}
